import React, { useRef } from 'react';
import { InfoIcon, Tooltip } from 'src/common';
import styled from 'styled-components';

const Container = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;

  svg {
    padding: 0;
    flex-shrink: 0;
    transform: scale(0.8);
  }
`;

interface InfoHintProps {
  children: React.ReactNode;
  tooltipText: string;
  place?: 'top' | 'bottom' | 'left' | 'right';
  maxWidth?: number;
  noIcon?: boolean;
}

const InfoHint: React.FC<InfoHintProps> = ({
  children,
  tooltipText,
  place = 'top',
  maxWidth = 400,
  noIcon = false,
}) => {
  const tooltipId = useRef(`info-tooltip-${Math.random().toString(36).substr(2, 9)}`);

  return (
    <>
      <Tooltip
        dataId={tooltipId.current}
        dataHtml={tooltipText}
        place={place}
        maxWidth={maxWidth}
        noIcon
        delayShow={200}
      />
      <Container data-tooltip-id={tooltipId.current} data-tooltip-html={tooltipText}>
        {children}
        {!noIcon && <InfoIcon cursorDefault />}
      </Container>
    </>
  );
};

export default InfoHint;
